var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({attrs:{"id":"close","role":"button","aria-label":"close"}},_vm.$listeners),[_c('i',{staticClass:"af-icons af-icons-cross"})])
}
var staticRenderFns = []

export { render, staticRenderFns }